export default {
	GET_UPDATE_PASSWORD: state => state.updatePassword,
}